// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 141) return "static/chunks/141-a81056443c62c6ac.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 557 ? "f10664bc" : chunkId) + "." + {"56":"5a692a369034e473","415":"88c250b2858b88f1","557":"d468adb160e69a32","838":"125b0a6deacbe548"}[chunkId] + ".js";
};